import React from "react";
import { schema } from "./validator";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router-dom";
import { useHandleForm } from "../../../hooks/useHandleForm";

import { IButton, FormField } from "../../../ui-kit";
import { useStatusMessage } from "../../../hooks/useStatusMessage";
import { authStore } from "../../../store/authStore";

import styles from "../LoginForm/LoginForm.module.scss";
import { LogoDarkLetters } from "../../../assets/customIcons";

export interface IChangePasswordForm {
  userId: number;
  token: string;
  newPassword: string;
  newPasswordRepeat: string;
  currentPassword: string;
}

interface IModalProps {
  onCancel?: () => void;
}

export const ChangePasswordForm: React.FC<IModalProps> = observer(
  ({ onCancel }) => {
    const history = useHistory();
    const searchString = new URLSearchParams(window.location.search);
    const code = searchString.get("code");
    const id = searchString.get("id") ?? authStore.userProfile?.id;
    const initialValues = {
      token: code,
      userId: id,
      newPassword: null,
      newPasswordRepeat: null,
      currentPassword: null,
    };

    const hasUrlParams = code && id;

    const {
      register,
      watch,
      handleSubmit,
      reset,
      formState: { errors, isSubmitting },
    } = useHandleForm(schema, initialValues);

    useStatusMessage(authStore.passwordStatus);

    const onSubmit = async (data: IChangePasswordForm) => {
      const result = await authStore.changePassword(
        data,
        hasUrlParams,
        history,
      );

      if (result?.success) {
        onCancel();
      }
    };

    return (
      <div className={styles.positioning}>
        <LogoDarkLetters />
        <div className={styles.wrapper}>
          <div className={styles.form}>
            <div className={styles.header}>
              <h1 className={styles.title}>Смена пароля</h1>
            </div>
            <form
              id="changePw"
              className={`${styles.form} ${styles.changeForm}`}
              onSubmit={handleSubmit(onSubmit)}
            >
              {!hasUrlParams && (
                <FormField
                  label="Текущий пароль"
                  name="currentPassword"
                  register={register}
                  type="password"
                  currentValue={watch().currentPassword}
                  isRequired
                  error={errors?.currentPassword?.message}
                />
              )}
              <FormField
                label="Новый пароль"
                name="newPassword"
                register={register}
                type="password"
                currentValue={watch().newPassword}
                isRequired
                error={errors?.newPassword?.message}
              />
              <FormField
                label="Подтверждение пароля"
                name="newPasswordRepeat"
                register={register}
                type="password"
                currentValue={watch().newPasswordRepeat}
                isRequired
                error={errors?.newPasswordRepeat?.message}
              />
            </form>
            <div className={styles.footer}>
              <IButton form="changePw" type="submit" disabled={isSubmitting}>
                Изменить
              </IButton>
              {!hasUrlParams && <IButton onClick={onCancel}>Закрыть</IButton>}
            </div>
          </div>
        </div>
      </div>
    );
  },
);
